module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_8011.2ef35e38.png";